import { IInstagramDailyHistoricalMetrics } from '@apis/instagram-hashtag/instagramHashtagApiModel';
import { IInstagramHashtagOverallMetrics } from '@instagram-account/redux/instagram-hashtag/insights/instagramHashtagInsightsModel';

/**
 *
 * Takes in an array of daily metrics objects and computes
 * the total metrics over the given array.
 *
 * @returns A consolidated version of the stats with the given daily metrics
 */
export function dailyMetricsToOverallMetrics(
  dailyMetrics: IInstagramDailyHistoricalMetrics[],
): IInstagramHashtagOverallMetrics {
  const { totalLikes, totalComments, totalPosts } = dailyMetrics.reduce(
    (acc, day) => {
      return {
        totalLikes: acc.totalLikes + day.likes.sum,
        totalComments: acc.totalComments + day.comments.sum,
        totalPosts: acc.totalPosts + day.documentCount,
      };
    },
    { totalLikes: 0, totalComments: 0, totalPosts: 0 },
  );

  const totalInteractions = totalLikes + totalComments;

  return {
    totalLikes,
    totalComments,
    totalInteractions,
    totalPosts,
  };
}
